export default __webpack_public_path__ + "static/media/EVENT26AsideR.a2635bb4.png";